import React from 'react';
import { useSelector } from 'react-redux';

import useQuestion from 'hooks/useQuestion';
import useActions from 'hooks/useActions';
import Question from 'components/Question';
import Spinner from 'components/Spinner';

import { sendAnswer, nextQuestion, askQuestion } from 'actions';

const QuestionWrapper = ({id, serieId, index}) => {
  const { question, state } = useQuestion(id);
  const dispatchSendAnswer = useActions(sendAnswer);
  const dispatchNextQuestion = useActions(nextQuestion);
  const dispatchAskQuestion = useActions(askQuestion);

  const onAskQuestion = (data) => {
    dispatchAskQuestion({...data, serie: serieId})
  }
  const onSend = (data) => {
    dispatchSendAnswer(id, serieId, data, {onSuccess: () => console.log("wee")})
  }
  const onNext = () => {
    dispatchNextQuestion(id);
  }

  return (
    <>
      {question ?
        <Question {...question} state={state} onSend={onSend} next={onNext} onAskQuestion={onAskQuestion} index={index}/>
      :
        <Spinner size="3x" />
      }
    </>
  );
}

export default QuestionWrapper;